import {Component} from '@angular/core';
import {Router} from '@angular/router';

import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {RoutesService} from './routes.service';

@Component({
  templateUrl: 'routing.component.html',
})
export class RoutingComponent {
  constructor(
    public router: Router,
    public routesService: RoutesService,
    public securityService: SecurityService,
    public eventsEmitterService: EventsEmitterService,
    public logger: LogService,
  ) {
    this.logger.log('App Init');
    this.logger.log('langId: ' + localStorage.getItem('langId'));
    this.logger.log('access_token: ' + this.securityService.getFromStorage('access_token'));
    this.logger.log('refresh_token: ' + this.securityService.getFromStorage('refresh_token'));
    let url = this.router.url;

    if (
      this.securityService.getFromStorage('access_token') != null &&
      this.securityService.getFromStorage('refresh_token') != null
    ) {
      this.logger.log('already logged in');

      this.routesService.getRoutes(url);

      //this.router.navigateByUrl(val.url);
    } else {
      this.logger.log('redirect to login');
      this.securityService.goToLogin();
    }
  }
}
